import { Reveal, Overline } from "./Reveal";
import { FOUNDERS } from "@/data/content";

export default function Founders() {
  return (
    <section className="bg-royal py-28 md:py-40" data-testid="founders-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <Overline light>As pessoas por trás</Overline>
          <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-white md:text-6xl">
            Conhece a <em>Creative.</em>
          </h2>
          <p className="mt-8 text-base leading-relaxed text-white/70 md:text-lg">
            Duas áreas diferentes que se complementam para criar uma solução completa.
          </p>
        </Reveal>

        <div className="mt-20 grid gap-16 md:grid-cols-2 md:gap-10">
          {FOUNDERS.map((f, i) => (
            <Reveal key={f.name} delay={i * 0.15}>
              <div className="group" data-testid={`founder-card-${f.name.toLowerCase()}`}>
                <div className="relative overflow-hidden rounded-xl border border-white/15">
                  <img
                    src={f.image}
                    alt={`${f.name}, Creative`}
                    loading="lazy"
                    className="aspect-[4/5] w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                  />
                  <span className="absolute bottom-5 left-5 rounded-full bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-royal">
                    {f.name}
                  </span>
                </div>
                <p className="mt-6 text-xs font-bold uppercase tracking-[0.25em] text-white/70">
                  {f.roles}
                </p>
                <p className="mt-4 max-w-md text-base leading-relaxed text-white/70">
                  {f.bio}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-24">
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-4 border-t border-white/15 pt-14">
            <span className="font-display text-2xl font-medium text-white/85 md:text-3xl">
              Diego
            </span>
            <span className="font-display text-2xl italic text-white/40 md:text-3xl">+</span>
            <span className="font-display text-2xl font-medium text-white/85 md:text-3xl">
              Michelle
            </span>
            <span className="font-display text-2xl italic text-white/40 md:text-3xl">=</span>
            <img src="/assets/logo-white.png" alt="Creative" className="h-8 w-auto md:h-10" />
          </div>
          <p className="mt-5 text-center text-xs font-semibold uppercase tracking-[0.25em] text-white/45">
            Criada por duas pessoas, uma equipa completa.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
